/* eslint-disable indent */
import { html, css, nothing, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { store } from '../../store/store.js';
import sharedStyles from '../../app/styles.js';
import {
    updateDraftSubItem,
    copyDraftSubItem,
    deleteDraftSubItem
} from '../../store/draft/draft.js';
import { previewElearning } from '../../store/preview/preview.js';
import {
    itemTypes,
    getIcon,
    itemTypeRenderer
} from '../../store/draft/types.js';
import { translate } from '../../helpers/translate.js';
import {
    toDuration,
    fromDuration,
} from '../../helpers/converters.js';
import { getItemChanges } from './helpers.js'
import { scrollIntoViewIfNeeded } from '../../helpers/dom.js';
import { selectRenderer } from '@vaadin/select/lit.js';
import '@sdb-develop/learning-frontend';
import '@polymer/paper-item/paper-item.js';
import '@polymer/paper-input/paper-input.js';
import '@vaadin/select/theme/material/vaadin-select.js';
import '@vaadin/context-menu/theme/material/vaadin-context-menu.js';
import '../elearning/sdb-microlearning-select-input.js';
import '../elearning/sdb-elearning-select-input.js';


@customElement('sdb-composition-draft-sub-item')
class SdbCompositionDraftSubItem extends connect(store)(LitElement) {

    @property({ type: String })
    accessor parentId;

    @property({ type: Object })
    accessor item;

    @state()
    accessor inEditMode = false;

    get deleteSubItemDialog() {
        return this.renderRoot.querySelector('#delete_sub_item_dialog');
    }

    get subItemBottom() {
        return this.renderRoot.querySelector('#sub_item_bottom');
    }

    stateChanged(state) {
        this.hasGlobalId = state.env.hasGlobalId;
        this.legacy = state.draft.current.compositionType === 2; // LegacyMicrolearnings
    }

    static get styles() {
        return [
            sharedStyles,
            css`
                /* css is a mess, fix in new layout */
                paper-icon-item {
                    margin-left: 0px !important;
                    background-color: white;
                }

                paper-item:not([disabled]) {
                    cursor: pointer;
                }

                paper-item-body {
                    border: none;
                    width: 100%;
                }

                paper-item-body div.title {
                    font-family: var(--font-family);
                    font-size: 16px;
                    font-weight: 500;
                    color: var(--text-primary);
                    --webkit-font-smoothing: antialiased;
                    margin-left: 26px;
                }

                iron-icon.fallback-icon, paper-icon-button {
                    color: rgba(0, 0, 0, .7);
                }

                paper-icon-item {
                    margin-left: 0px !important;
                    background-color: white;
                    width: 100%;
                    max-width: 920px;
                }

                paper-icon-button, iron-icon {
                    color: rgba(0, 0, 0, .7);
                }

                paper-icon-button[disabled] {
                    color: var(--paper-icon-button-disabled-text, var(--disabled-text-color));
                }

                iron-icon.medium {
                    --iron-icon-height: 24px;
                    --iron-icon-width: 24px;
                }

                .flex-row {
                    display: flex;
                    flex-direction: row;
                }

                .flex-column {
                    display: flex;
                    flex-direction: column;
                }

                .edit-mode {
                    margin-left: 50px;
                    margin-right: 20px;
                }

                paper-input.small {
                    max-width: 300px;
                }
            `,
        ];
    }

    render() {
        const update = (changes) => store.dispatch(updateDraftSubItem({
            itemId: this.parentId,
            subItemId: this.item.uniqueId,
            changes
        }));

        return html`
            <div class="flex-row">
                <paper-icon-item>
                    <div slot="item-icon"></div>
                    <sdb-content-icon
                        icon="${getIcon(this.item.type)}"
                        style="margin-left: -10px;"
                        class="medium">
                    </sdb-content-icon>
                    <paper-item-body
                        style="cursor: pointer;"
                        @click=${() => { this._toggleEditMode(); }}>
                        <div class="title">${this.item.name}</div>
                    </paper-item-body>
                    <vaadin-context-menu
                        open-on="click"
                        .items=${this._getMenuItems()}
                        @item-selected=${(e) => {
                            e.stopPropagation();
                            e.detail.value?.action?.();
                        }}>
                        <sdb-content-iconbutton icon="fal fa-ellipsis-vertical"></sdb-content-iconbutton>
                    </vaadin-context-menu>
                </paper-icon-item>
            </div>

            ${this.inEditMode ? html`
                <div>
                    <div class="flex-column edit-mode">
                        <sdb-elearning-select-input
                            id="elearning_select"
                            labelText=${translate('blockItem')}
                            launchId=${this.item.launchId}
                            launchName=${this.item.elearningItemName}
                            @itemSelected=${(e) => {
                                update(getItemChanges(this.item, e.detail.elearning));
                            }}>
                        </sdb-elearning-select-input>
                        <paper-input
                            id="title_input"
                            transparent
                            label=${translate('displayTitle')}
                            value=${this.item.name}
                            @change="${(e) => { update({ name: e.target.value }); }}">
                        </paper-input>

                        <vaadin-select
                            id="itemtype_select"
                            transparent
                            label=${translate('blockItemType')}
                            value=${this.item.type}
                            @value-changed=${(e) => { update({ type: e.target.value }); }}
                            ${selectRenderer(itemTypeRenderer, itemTypes)}>
                        </vaadin-select>

                        <paper-input
                            id="duration_input"
                            transparent
                            class="small"
                            type="number"
                            label=${translate('duration')}
                            value=${fromDuration(this.item.duration)}
                            @change=${(e) => { update({ duration: toDuration(e.target.value) }); }}>
                            <div slot="suffix">${translate('minutes')}</div>
                        </paper-input>

                    </div>

                    <div style="height: 15px;"></div>
                </div>` : nothing
            }

            <div id="sub_item_bottom"></div>

            <sdb-dialog
                type="confirm"
                id="delete_sub_item_dialog"
                heading=${translate('deleteBlockItemHeading')}
                confirmCaption=${translate('delete')}
                @confirm=${() => { store.dispatch(deleteDraftSubItem({ itemId: this.parentId, subItemId: this.item.uniqueId })); }}>
            </sdb-dialog>
        `;
    }

    _getMenuItems() {
        const menuItems = [
            {
                text: translate('duplicate'),
                action: () => store.dispatch(copyDraftSubItem({ itemId: this.parentId, subItem: this.item })),
            },
            {
                text: translate('preview'),
                action: () => store.dispatch(previewElearning({ item: this.item })),
                disabled: !this.item.launchId,
            },
            { component: 'hr' },
            {
                text: translate('delete'),
                action: () => this.deleteSubItemDialog.open(),
                className: 'warning',
            },
        ];

        return menuItems;
    }

    _toggleEditMode() {
        this.inEditMode = !this.inEditMode;
        if (this.inEditMode) {
            setTimeout(() => {
                scrollIntoViewIfNeeded(this.subItemBottom);
            }, 0);
        }
    }
}

